import dayjs from 'dayjs';

export const compareVersions = (a = '', b = '') => {
  const left = String(a)
    .split('.')
    .map((part) => Number(part) || 0);
  const right = String(b)
    .split('.')
    .map((part) => Number(part) || 0);
  const length = Math.max(left.length, right.length);

  for (let i = 0; i < length; i += 1) {
    const na = left[i] || 0;
    const nb = right[i] || 0;
    if (na > nb) return 1;
    if (na < nb) return -1;
  }

  return 0;
};

export const isNewerVersion = (candidate, current) => compareVersions(candidate, current) > 0;

export const groupFirmwareByVersion = (files = []) => {
  const groups = files.reduce((acc, file) => {
    const version = file?.version;
    if (!version) return acc;

    const current = acc.get(version) ?? {
      version,
      files: [],
      models: new Set(),
      modified_at: file.modified_at || '',
    };

    current.files.push(file);
    if (file.device_model) current.models.add(file.device_model);
    if (file.modified_at && file.modified_at > current.modified_at) {
      current.modified_at = file.modified_at;
    }

    acc.set(version, current);
    return acc;
  }, new Map());

  return Array.from(groups.values())
    .map((group) => ({ ...group, models: Array.from(group.models) }))
    .sort((a, b) => compareVersions(b.version, a.version));
};

export const summarizeTestDevices = (devices = []) => {
  const byVersion = devices.reduce((acc, device) => {
    const version = device.current_version || device.reported_version || 'неизвестно';
    acc[version] = (acc[version] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(byVersion)
    .map(([version, count]) => ({ version, count }))
    .sort((a, b) => compareVersions(b.version, a.version));
};

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = dayjs(value);
  return date.isValid() ? date.format('DD.MM.YYYY HH:mm') : value;
};

export const getDeviceRowStatus = (device) => {
  if (device?.excluded_at) return 'excluded';
  if (device?.done) return 'done';
  return 'pending';
};

export const getApiErrorMessage = (err, fallback) => err?.response?.data?.error || fallback;
